export default "__VITE_ASSET__CXkad8PT__"